import React from "react";

/* Stroke Text
============================================================================= */

const StrokeText = ({
	size = "text-7xl",
	color = "text-stroke-blue",
	alignment = "text-center",
	text,
	hover = false,
}) => {
	// Config

	// Render
	return (
		<div
			className={`transition-transform scale-100  transform-gpu  ${
				hover ? "hover:scale-[1.035] cursor-pointer " : ""
			}`}
		>
			<div className={`relative flex items-center justify-center`}>
				<h2
					className={`phosphate ${size} text-white relative z-50 uppercase tracking-wide ${alignment}`}
				>
					{text}
				</h2>
				<h2
					className={`absolute text-stroke  phosphate ${size} text-white z-30 uppercase tracking-wide ${alignment}`}
				>
					{text}
				</h2>
				<h2
					className={`absolute ${color}  phosphate ${size} text-white uppercase tracking-wide ${alignment}`}
				>
					{text}
				</h2>
			</div>
		</div>
	);
};

/* Export
============================================================================= */

export default StrokeText;
